import "../styles/Footer.scss"

export default function Footer() {
  return (
    <footer>
      <p>Copyright &copy; 2023 Paweł Izdebski</p>
      <a href="https://github.com/zucek20/portfolio" target="_blank" rel="noreferrer" title="repozytorium portfolio">GitHub</a>
    </footer>
  )
}